<div class="px-5">
    <h1>Ventas</h1>
    <app-admin-table [mapHeader]="mapHeader" [queryset]="data$" [exportFile]="'Ventas'"></app-admin-table>
</div>